import React from 'react';
import {
  Button,
  Dialog,
} from 'anf-core-react';
import PropTypes from 'prop-types';
import Tmnt from '../../../Tmnt/Tmnt';
import SavedAddressCard from '../SavedAddress/SavedAddressCard';

export default function AddressSelectionModal({
  isOpen, addressData, textFor, shippingAddress,
  onUseThisAddress, onAddNewAddress,
  setModalVisibility,
}) {
  const closeModal = () => {
    setModalVisibility(false);
  };

  const addressList = () => addressData?.map(((address) => (
    <div className="data-card saved-address-wrapper" key={address.addressId}>
      <div className="data-card-content">
        <SavedAddressCard address={address} isCountryFlagVisible />
        <div className="button-container">
          <Button
            isFullWidth
            ariaLabel={shippingAddress.addressId === address.addressId
              ? textFor?.selectedAddress?.value
              : textFor?.checkoutUseThisAddress?.value}
            variant={shippingAddress.addressId === address.addressId ? 'secondary' : 'tertiary-dark'}
            onClick={() => {
              onUseThisAddress(address, shippingAddress.addressId === address.addressId);
            }}
          >
            {shippingAddress.addressId === address.addressId
              ? textFor?.selectedAddress?.value
              : textFor?.checkoutUseThisAddress?.value}
          </Button>
        </div>
      </div>
    </div>
  )
  ));

  return (
    <Dialog
      heading={(
        <h2 className="h2" data-testid="change-shipping-address-modal-header">
          <Tmnt tmnt={textFor?.changeShippingAddress} />
        </h2>
      )}
      classList="change-shipping-address-modal-wrapper"
      id="modal-changeShippingAddress"
      onClose={closeModal}
      isOpen={isOpen}
      onOverlayClick={closeModal}
      closeButtonLabel="Close"
    >

      <Button
        ariaLabel={textFor?.addNewAddress?.key}
        isFullWidth
        onClick={onAddNewAddress}
        variant="secondary"
        type="button"
      >
        {textFor?.addNewAddress?.value}
      </Button>
      <h2
        className="saved-address-section-heading"
        data-property={textFor?.savedAddress?.key}
      >
        {textFor?.savedAddress?.value}
      </h2>
      {addressList()}
    </Dialog>
  );
}

AddressSelectionModal.propTypes = {
  isOpen: PropTypes.bool,
  textFor: PropTypes.instanceOf(Object),
  setModalVisibility: PropTypes.func,
  addressData: PropTypes.arrayOf(PropTypes.shape({
    address: PropTypes.shape({
      address1: PropTypes.string,
      address2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      postalCode: PropTypes.string,
      sameDayStoreId: PropTypes.string,
      addressId: PropTypes.string,
      country: PropTypes.string,
      isAddressVerified: PropTypes.bool,
      email: PropTypes.string,
      isBillingAllowed: PropTypes.bool,
      isDefaultBilling: PropTypes.bool,
      isDefaultShipping: PropTypes.bool,
      isShippingAllowed: PropTypes.bool,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      orgName: PropTypes.string,
      pickUpStoreId: PropTypes.string,
      poBox: PropTypes.bool,
      title: PropTypes.string,
      isSelectedAddress: PropTypes.bool,
    }),
  })),
  shippingAddress: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    sameDayStoreId: PropTypes.string,
    addressId: PropTypes.string,
    country: PropTypes.string,
    isAddressVerified: PropTypes.bool,
    email: PropTypes.string,
    isBillingAllowed: PropTypes.bool,
    isDefaultBilling: PropTypes.bool,
    isDefaultShipping: PropTypes.bool,
    isShippingAllowed: PropTypes.bool,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    orgName: PropTypes.string,
    pickUpStoreId: PropTypes.string,
    poBox: PropTypes.bool,
    title: PropTypes.string,
    isSelectedAddress: PropTypes.bool,
  }),
  onAddNewAddress: PropTypes.func,
  onUseThisAddress: PropTypes.func,
};

AddressSelectionModal.defaultProps = {
  setModalVisibility: () => { },
  addressData: [
    {
      address: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
        isSelectedAddress: false,
        addressId: '',
        country: '',
        isAddressVerified: false,
        email: '',
        isBillingAllowed: false,
        isDefaultBilling: false,
        isDefaultShipping: false,
        isShippingAllowed: false,
        firstName: '',
        lastName: '',
        orgName: '',
        pickUpStoreId: '',
        poBox: false,
        title: '',
      },
    },
  ],
  isOpen: false,
  textFor: {},
  onAddNewAddress: () => { },
  onUseThisAddress: () => { },
  shippingAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    isSelectedAddress: false,
    addressId: '',
    country: '',
    isAddressVerified: false,
    email: '',
    isBillingAllowed: false,
    isDefaultBilling: false,
    isDefaultShipping: false,
    isShippingAllowed: false,
    firstName: '',
    lastName: '',
    orgName: '',
    pickUpStoreId: '',
    poBox: false,
    title: '',
  },
};
